// export const urlLE = 'https://inc.catech.site/';
// export const urlLE = 'http://83.174.213.238:8080/';
export const urlLE = 'http://93.90.221.53/';

// export const API_URL = 'http://localhost:81/';
export const API_URL = 'http://93.90.221.53:81/';